var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiniProfileStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.825,
    height: 116.402,
    viewBox: "0 0 185.825 116.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48160",
    "data-name": "Group 48160",
    transform: "translate(-998.189 -158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140516",
    "data-name": "Path 140516",
    d: "M54.533,76.341l-6.1,3.055L45.381,85.5a.867.867,0,0,1-.772.481.819.819,0,0,1-.773-.48L40.781,79.4l-6.1-3.055a.865.865,0,0,1-.481-.779.876.876,0,0,1,.481-.78l6.1-3.052,3.057-6.109a.9.9,0,0,1,1.544,0l3.053,6.11,6.1,3.052a.872.872,0,0,1,.481.779A.859.859,0,0,1,54.533,76.341Z",
    transform: "translate(1129 143.417)",
    fill: "#e74973",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140519",
    "data-name": "Path 140519",
    d: "M54.533,76.341l-6.1,3.055L45.381,85.5a.867.867,0,0,1-.772.481.819.819,0,0,1-.773-.48L40.781,79.4l-6.1-3.055a.865.865,0,0,1-.481-.779.876.876,0,0,1,.481-.78l6.1-3.052,3.057-6.109a.9.9,0,0,1,1.544,0l3.053,6.11,6.1,3.052a.872.872,0,0,1,.481.779A.859.859,0,0,1,54.533,76.341Z",
    transform: "translate(963.986 188.417)",
    fill: "#e74973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140517",
    "data-name": "Path 140517",
    d: "M20.331,20.85l-6.1,3.055-3.055,6.109a.867.867,0,0,1-.772.481.816.816,0,0,1-.772-.48L6.578,23.908l-6.1-3.056A.865.865,0,0,1,0,20.073a.876.876,0,0,1,.481-.78l6.1-3.052,3.057-6.109a.9.9,0,0,1,1.544,0l3.053,6.11,6.1,3.052a.872.872,0,0,1,.481.779A.859.859,0,0,1,20.331,20.85Z",
    transform: "translate(1128 158)",
    fill: "#e74973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140518",
    "data-name": "Path 140518",
    d: "M36.264,5.2a.433.433,0,0,1-.237.386L32.8,6.937l-1.348,3.232a.434.434,0,0,1-.773,0L29.327,6.937,26.1,5.589a.433.433,0,0,1,0-.772l3.231-1.348L30.675.237a.434.434,0,0,1,.773,0L32.8,3.469l3.23,1.349A.428.428,0,0,1,36.264,5.2Z",
    transform: "translate(1126 158)",
    fill: "#e74973",
    opacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniProfileStarIcon);
export default __webpack_public_path__ + "static/media/MiniProfileStarIcon.ab2881a3f4e80400667887e47270e1b6.svg";
export { ForwardRef as ReactComponent };